/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface CreateGuestCardDTO
 */
export interface CreateGuestCardDTOOptional {
  /**
   *
   * @type {string}
   * @memberof CreateGuestCardDTO
   */
  cardNum?: string;
}

export interface CreateGuestCardDTO extends CreateGuestCardDTOOptional {
  /**
   *
   * @type {string}
   * @memberof CreateGuestCardDTO
   */
  cardNum?: string;
}

export interface CreateGuestCardDTOTrackedI {
  /**
   *
   * @type {string}
   * @memberof CreateGuestCardDTO
   */
  cardNum?: string;
  cardNumIsSet: boolean;
}

transformDatesMap.set(
  "CreateGuestCardDTO",
  function (model: CreateGuestCardDTO) {},
);

export type CreateGuestCardDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  cardNum: PropertyMeta<MetaTypeBase<string>>;
}>;

export var CreateGuestCardDTOMeta: CreateGuestCardDTOMetaI =
  {} as CreateGuestCardDTOMetaI;
CreateGuestCardDTOMeta = typeMeta("CreateGuestCardDTO", {
  cardNum: propertyMeta("cardNum", false, false, false, MetaTypesBase.string),
});

const metaI = CreateGuestCardDTOMeta;

registerMeta(() => {});

export class CreateGuestCardDTOTracked implements CreateGuestCardDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  cardNum__I?: string = undefined;
  cardNumIsSet: boolean = false;
  set cardNum(v: undefined | string) {
    if (v !== undefined) {
      this.cardNum__I = v;
      this.cardNumIsSet = true;
    } else {
      this.cardNum__I = v || undefined;
      this.cardNumIsSet = false;
    }
    this.changeTracker = true;
  }
  get cardNum() {
    return this.cardNum__I;
  }
  constructor(config?: CreateGuestCardDTOOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: CreateGuestCardDTOOptional,
    options?: AssignOptions,
  ): CreateGuestCardDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.cardNum && this.cardNumApplyFilter(optionsRequired.filter)) {
      this.cardNum = config.cardNum;
      if (optionsRequired.unassign) this.cardNumIsSet = false;
      else this.cardNumIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CreateGuestCardDTOTrackedI {
    const cloned = {} as CreateGuestCardDTOTrackedI;
    if (
      this.cardNumIsSetDeep() &&
      this.cardNumApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.cardNumIsSet = true;
      cloned.cardNum = this.cardNum;
    } else {
      //cloned.cardNumIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CreateGuestCardDTOTrackedI {
    if (!this.cardNumApplyFilter(filter)) this.cardNumIsSet = false;

    return this;
  }
  cardNumApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CreateGuestCardDTOMeta.cardNum,
      CreateGuestCardDTOMeta,
      this.cardNum,
      this,
    );
  }
  cardNumIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.cardNumIsSet && this.cardNumApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.cardNumIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
